module.exports = __webpack_public_path__ + "47c40dd35cfc50e7ff79f3cbde99ffa4.png";